<template>
  <div class="floating-wrapper container">
    <button class="floating-action-button"
            @click="$emit('click')"
            @keydown.esc="$emit('close')"
    >
      <fab-icon class="floating-action-button-icon"/>
      <span class="floating-action-button-text">{{ $t('exportCalculation') }}</span>
    </button>
  </div>
</template>

<script>
  import fabIcon from "@/assets/icons/share_export_icon_horti.svg?inline";
  export default {
    name: "FloatingActionButton",
    components: {fabIcon}
  }
</script>

<style lang="scss">
  .floating-wrapper {
    position: sticky;
    bottom: 20px;
    display: flex;
    justify-content: flex-end;
    pointer-events: none;
  }

  .floating-action-button {
    $size: 64px;

    pointer-events: all;
    margin-top: 20px;
    margin-right: 20px;

    height: $size;
    padding: 0 25px;
    border: 1px solid transparent;
    border-radius: $size;
    background: $white;
    line-height: $size;
    color: $pink-500;
    text-align: center;
    box-shadow: 0 2px 7px rgba(0,0,0,0.11);
    transition: box-shadow 0.2s, border-color 0.2s;

    &:hover {
      cursor: pointer;
      box-shadow: 0 2px 7px rgba(0,0,0,0.25);
    }

    &:focus {
      outline: none;
      border: 1px solid $pink-500;
    }

    .floating-action-button-icon {
      width: 15px;
      height: auto;

      #Export-icon {
        fill: $pink-500;
      }
    }

    .floating-action-button-text {
      margin-left: 5px;
    }
  }
</style>
